<div class="size-full">
  @switch (editMode()) {
    @case (editModes.ObjectDetection) {
      <lib-object-detection-panel
        [ready]="detectionReady()"
        [loading]="detectionLoading()"
        [objects]="detectedObjects()"
        [errorKey]="detectionErrorKey()"
        [downloadUrl]="detectionDownloadUrl()"
        (detectRequested)="detectionRequested.emit()"
        (cancelRequested)="detectionCancelled.emit()" />
    }
    @case (editModes.Crop) {
      <lib-crop-panel
        [imageSize]="imageSize()"
        (changed)="onDraftChanged($event)"
        (apply)="onApply()"
        (cancelRequested)="onCancel()">
      </lib-crop-panel>
    }
    @case (editModes.Resize) {
      <lib-resize-panel
        [imageSize]="imageSize()"
        (changed)="onDraftChanged($event)"
        (apply)="onApply()"
        (cancelRequested)="onCancel()">
      </lib-resize-panel>
    }
    @case (editModes.Rotate) {
      <lib-rotate-panel
        [imageSize]="imageSize()"
        (changed)="onDraftChanged($event)"
        (apply)="onApply()"
        (cancelRequested)="onCancel()">
      </lib-rotate-panel>
    }
    @case (editModes.Filter) {
      <lib-filter-panel
        [editorOptions]="editorOptions()"
        [imageSize]="imageSize()"
        (changed)="onDraftChanged($event)"
        (apply)="onApply()"
        (cancelRequested)="onCancel()">
      </lib-filter-panel>
    }
    @case (editModes.Watermark) {
      <lib-watermark-panel
        [imageSize]="imageSize()"
        (changed)="onDraftChanged($event)"
        (apply)="onApply()"
        (cancelRequested)="onCancel()">
      </lib-watermark-panel>
    }
    @case (editModes.Deskew) {
      <lib-deskew-panel
        [imageSize]="imageSize()"
        (changed)="onDraftChanged($event)"
        (apply)="onApply()"
        (cancelRequested)="onCancel()">
      </lib-deskew-panel>
    }
    @case (editModes.Animation) {
      <lib-animation-panel [imageSize]="imageSize()" (apply)="onApply()" (cancelRequested)="onCancel()">
      </lib-animation-panel>
    }
    @case (editModes.Merge) {
      <lib-merge-panel [imageSize]="imageSize()" (apply)="onMergeApply()" (cancelRequested)="onCancel()">
      </lib-merge-panel>
    }
  }
</div>
